import ExhibitorDashboardView from "@/views/exhibitor/dashboard/DashboardView";
import MyAccountView from "@/views/MyAccountView";

export default [
  {
    name: "pages.exhibitor.dashboard",
    path: "dashboard",
    component: ExhibitorDashboardView
  },
  {
    name: "pages.exhibitor.my-account",
    path: "my-account",
    component: MyAccountView
  }
  
];
